import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumContainerStatus implements BaseEnumType {
  private static allValues: EnumContainerStatus[] = []; // make sure this is top-most
  
  public static cleanAndIn = new EnumContainerStatus(0, "CleanAndIn", "enum_container_status_clean_and_in");
  public static fullAndIn = new EnumContainerStatus(1, "FullAndIn", "enum_container_status_full_and_in");
  public static out = new EnumContainerStatus(2, "Out", "enum_container_status_out");
  public static lost = new EnumContainerStatus(3, "Lost", "enum_container_status_lost");
  public static dirtyAndIn = new EnumContainerStatus(4, "DirtyAndIn", "enum_container_status_dirty_and_in");
  public static outOfOrder = new EnumContainerStatus(5, "OutOfOrder", "enum_container_status_out_of_order");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumContainerStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isCleanAndIn() { return this === EnumContainerStatus.cleanAndIn; }
  public isFullAndIn() { return this === EnumContainerStatus.fullAndIn; }
  public isOut() { return this === EnumContainerStatus.out; }
  public isLost() { return this === EnumContainerStatus.lost; }
  public isDirtyAndIn() { return this === EnumContainerStatus.dirtyAndIn; }
  public isOutOfOrder() { return this === EnumContainerStatus.outOfOrder; }

  public static getValues(): readonly EnumContainerStatus[] {
    return EnumContainerStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumContainerStatus[] {
    return EnumContainerStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumContainerStatus {
    const found = EnumContainerStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumContainerStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumContainerStatus): EnumContainerStatus {
    const found = name ? EnumContainerStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumContainerStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumContainerStatus>): boolean {
    return this.key === other?.key;
  }
}